module.exports = __webpack_public_path__ + "static/media/ba.8ae0e195.jpg";